import * as EntityClasses from "@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g";
// import * as Entities from "@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g";
import { jsonLightReadStringPropertyValue } from "@msdyn365-commerce/retail-proxy/dist/externals";

/**
 * PropertyBag entity interface.
 */
export interface IPropertyBag {
  Keywords?: string[];
  Name?: string;
}

/**
 * BinaryMetadata entity interface.
 */
export interface IBinaryMetadata {
  ForceUserDownload?: boolean;
  Copyright?: string;
  ContentType?: string;
  Extension?: string;
  BinaryId?: string;
}

/**
 * Asset entity interface.
 */
export interface IAsset {
  Type?: string;
  LastModified?: Date;
  LastModifiedBy?: string;
  Id?: string;
  SourceId?: string;
  CmsId?: string;
  State?: string;
  IsCheckedOutToMe?: boolean;
  CheckedoutToLocale?: string;
  CheckedoutToMarket?: string;
  IsPublished?: boolean;
  ErrorDetails?: string;
  PublicUrl?: string;
  PreviewUrl?: string;
  PropertyBag?: IPropertyBag;
  BinaryMetadata?: IBinaryMetadata;
  ProcessingStatus?: string;
}

/**
 * LTSGetProductAssetResponse entity interface.
 */
export interface ILTSGetProductAssetResponse {
  TotalAssets?: number;
  Assets?: IAsset[];
  AssetMetadataType?: string;
  IsReleaseGroupLocked?: boolean;
  FeatureFlags?: IFeatureFlags;
  SiteDisplayName?: string;
  SupportedExtensions?: string[];
  IsVideoEnabled?: boolean;
}

/**
 * FeatureFlags entity interface.
 */
export interface IFeatureFlags {
  IsPublishAuthorizationEnabled?: boolean;
  IsImagePublishBlocked?: boolean;
  IsFilePublishBlocked?: boolean;
  IsVideoPublishBlocked?: boolean;
  IsManualBinaryLocalizationEnabled?: boolean;
}

/**
 * PropertyBag entity class.
 */
export class PropertyBagExtensionClass implements IPropertyBag {
  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public Keywords: string[];

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public Name: string;

  // Navigation properties names

  /**
   * Construct an object from odata response.
   * @param {any} odataObject The odata result object.
   */
  constructor(odataObject?: any) {
    odataObject = odataObject || {};
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.Keywords = undefined;
    if (odataObject.Keywords) {
      this.Keywords = [];
      for (var i = 0; i < odataObject.Keywords.length; i++) {
        if (odataObject.Keywords[i]) {
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.Keywords[i] = odataObject.Keywords[i];
        } else {
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.Keywords[i] = undefined;
        }
      }
    }

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.Name = odataObject.Name;
  }
}

/**
 * BinaryMetadata entity class.
 */
export class BinaryMetadataExtensionClass implements IBinaryMetadata {
  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public ForceUserDownload: boolean;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public Copyright: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public ContentType: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public Extension: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public BinaryId: string;

  // Navigation properties names

  /**
   * Construct an object from odata response.
   * @param {any} odataObject The odata result object.
   */
  constructor(odataObject?: any) {
    odataObject = odataObject || {};
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.ForceUserDownload = odataObject.ForceUserDownload;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.Copyright = odataObject.Copyright;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.ContentType = odataObject.ContentType;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.Extension = odataObject.Extension;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.BinaryId = odataObject.BinaryId;
  }
}

/**
 * Asset entity class.
 */
export class AssetExtensionClass implements IAsset {
  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public Type: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public LastModified: Date;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public LastModifiedBy: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public Id: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public SourceId: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public CmsId: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public State: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public IsCheckedOutToMe: boolean;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public CheckedoutToLocale: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public CheckedoutToMarket: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public IsPublished: boolean;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public ErrorDetails: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public PublicUrl: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public PreviewUrl: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public PropertyBag: IPropertyBag;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public BinaryMetadata: IBinaryMetadata;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public ProcessingStatus: string;

  // Navigation properties names

  /**
   * Construct an object from odata response.
   * @param {any} odataObject The odata result object.
   */
  constructor(odataObject?: any) {
    odataObject = odataObject || {};
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.Type = odataObject.Type;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.LastModified =
      odataObject.LastModified instanceof Date
        ? odataObject.LastModified
        : odataObject.LastModified
        ? jsonLightReadStringPropertyValue(
            odataObject.LastModified,
            "Edm.DateTimeOffset",
            false,
          )
        : undefined;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.LastModifiedBy = odataObject.LastModifiedBy;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.Id = odataObject.Id;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.SourceId = odataObject.SourceId;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.CmsId = odataObject.CmsId;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.State = odataObject.State;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.IsCheckedOutToMe = odataObject.IsCheckedOutToMe;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.CheckedoutToLocale = odataObject.CheckedoutToLocale;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.CheckedoutToMarket = odataObject.CheckedoutToMarket;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.IsPublished = odataObject.IsPublished;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.ErrorDetails = odataObject.ErrorDetails;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.PublicUrl = odataObject.PublicUrl;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.PreviewUrl = odataObject.PreviewUrl;

    if (odataObject.PropertyBag === null) {
      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      this.PropertyBag = undefined;
    } else if (odataObject.PropertyBag["@odata.type"] == null) {
      this.PropertyBag = new PropertyBagExtensionClass(odataObject.PropertyBag);
    } else {
      var className: string = odataObject.PropertyBag["@odata.type"];
      className = className
        .substr(className.lastIndexOf(".") + 1)
        .concat("Class");
      // @ts-ignore
      if (EntityClasses[className]) {
        // @ts-ignore
        this.PropertyBag = new EntityClasses[className](
          odataObject.PropertyBag,
        );
      }
    }

    if (odataObject.BinaryMetadata === null) {
      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      this.BinaryMetadata = undefined;
    } else if (odataObject.BinaryMetadata["@odata.type"] == null) {
      this.BinaryMetadata = new BinaryMetadataExtensionClass(
        odataObject.BinaryMetadata,
      );
    } else {
      var className: string = odataObject.BinaryMetadata["@odata.type"];
      className = className
        .substr(className.lastIndexOf(".") + 1)
        .concat("Class");
      // @ts-ignore
      if (EntityClasses[className]) {
        // @ts-ignore
        this.BinaryMetadata = new EntityClasses[className](
          odataObject.BinaryMetadata,
        );
      }
    }

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.ProcessingStatus = odataObject.ProcessingStatus;
  }
}

/**
 * FeatureFlags entity class.
 */
export class FeatureFlagsExtensionClass implements IFeatureFlags {
  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public IsPublishAuthorizationEnabled: boolean;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public IsImagePublishBlocked: boolean;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public IsFilePublishBlocked: boolean;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public IsVideoPublishBlocked: boolean;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public IsManualBinaryLocalizationEnabled: boolean;

  // Navigation properties names

  /**
   * Construct an object from odata response.
   * @param {any} odataObject The odata result object.
   */
  constructor(odataObject?: any) {
    odataObject = odataObject || {};
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.IsPublishAuthorizationEnabled =
      odataObject.IsPublishAuthorizationEnabled;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.IsImagePublishBlocked = odataObject.IsImagePublishBlocked;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.IsFilePublishBlocked = odataObject.IsFilePublishBlocked;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.IsVideoPublishBlocked = odataObject.IsVideoPublishBlocked;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.IsManualBinaryLocalizationEnabled =
      odataObject.IsManualBinaryLocalizationEnabled;
  }
}

/**
 * LTSGetProductAssetResponse entity class.
 */
export class LTSGetProductAssetResponseExtensionClass
  implements ILTSGetProductAssetResponse {
  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public TotalAssets: number;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public Assets: IAsset[];

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public AssetMetadataType: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public IsReleaseGroupLocked: boolean;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public FeatureFlags: IFeatureFlags;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public SiteDisplayName: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public SupportedExtensions: string[];

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public IsVideoEnabled: boolean;

  // Navigation properties names

  /**
   * Construct an object from odata response.
   * @param {any} odataObject The odata result object.
   */
  constructor(odataObject?: any) {
    odataObject = odataObject || {};
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.TotalAssets = odataObject.TotalAssets;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.Assets = undefined;
    if (odataObject.Assets) {
      this.Assets = [];
      for (var i = 0; i < odataObject.Assets.length; i++) {
        if (odataObject.Assets[i]) {
          if (odataObject.Assets[i]["@odata.type"]) {
            var className: string = odataObject.Assets[i]["@odata.type"];
            className = className
              .substr(className.lastIndexOf(".") + 1)
              .concat("Class");
            // @ts-ignore
            if (EntityClasses[className]) {
              // @ts-ignore
              this.Assets[i] = new EntityClasses[className](
                odataObject.Assets[i],
              );
            }
          } else {
            this.Assets[i] = new AssetExtensionClass(odataObject.Assets[i]);
          }
        } else {
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.Assets[i] = undefined;
        }
      }
    }

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.AssetMetadataType = odataObject.AssetMetadataType;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.IsReleaseGroupLocked = odataObject.IsReleaseGroupLocked;

    if (odataObject.FeatureFlags === null) {
      // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
      this.FeatureFlags = undefined;
    } else if (odataObject.FeatureFlags["@odata.type"] == null) {
      this.FeatureFlags = new FeatureFlagsExtensionClass(
        odataObject.FeatureFlags,
      );
    } else {
      var className: string = odataObject.FeatureFlags["@odata.type"];
      className = className
        .substr(className.lastIndexOf(".") + 1)
        .concat("Class");
      // @ts-ignore
      if (EntityClasses[className]) {
        // @ts-ignore
        this.FeatureFlags = new EntityClasses[className](
          odataObject.FeatureFlags,
        );
      }
    }

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.SiteDisplayName = odataObject.SiteDisplayName;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.SupportedExtensions = undefined;
    if (odataObject.SupportedExtensions) {
      this.SupportedExtensions = [];
      for (var i = 0; i < odataObject.SupportedExtensions.length; i++) {
        if (odataObject.SupportedExtensions[i]) {
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.SupportedExtensions[i] = odataObject.SupportedExtensions[i];
        } else {
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.SupportedExtensions[i] = undefined;
        }
      }
    }

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.IsVideoEnabled = odataObject.IsVideoEnabled;
  }
}
